<script>
import { Logotypes } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Logotypes List' }
    }
  },
  methods: {
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [
            {
              component: 'el-tab-pane',
              attrs: {
                label: 'Ogólne'
              },
              children: [
                new fields.Input({
                  label: 'Nazwa',
                  modelPath: [this, 'form', 'name'],
                  required: true
                }),
                new fields.Image({
                  label: 'Grafika desktop',
                  modelPath: [this, 'form', 'desktop_image']
                }),
                new fields.Input({
                  label: 'Mapa desktop',
                  modelPath: [this, 'form', 'desktop_map'],
                  type: 'textarea'
                }),
                new fields.Image({
                  label: 'Grafika tablet',
                  modelPath: [this, 'form', 'tablet_image']
                }),
                new fields.Input({
                  label: 'Mapa tablet',
                  modelPath: [this, 'form', 'tablet_map'],
                  type: 'textarea'
                }),
                new fields.Image({
                  label: 'Grafika mobile',
                  modelPath: [this, 'form', 'mobile_image']
                }),
                new fields.Input({
                  label: 'Mapa mobile',
                  modelPath: [this, 'form', 'mobile_map'],
                  type: 'textarea'
                })
              ]
            }
          ]
        }
      ]
    }
  },
  computed: {
    service() {
      return Logotypes
    }
  }
}
</script>
